export default __webpack_public_path__ + "static/media/image-50.762f7a8b.png";